import angular from "angular";
import shajs from "sha.js";
export default angular.module("services.shajs",[]).factory("shajs",function () {
  return shajs;
}).name;


// WEBPACK FOOTER //
// ./src/ui/app/services/sha.js